/*
 * @Date: 2022-02-10 16:11:12
 * @LastEditors: lei2jun
 * @LastEditTime: 2022-02-18 14:28:25
 * @Description: 组件开发工具支持函数
 */
let devServerWS = null

/**
 * 过滤掉本地正在开发的组件
 * @param {[{name:string}]} targetComponents 被过滤的组件列表
 * @param {[{name:string}]} devComponents 开发中的组件列表
 */
export function filterDevComponents(targetComponents, devComponents) {
    const devComponentsMap = devComponents.reduce((acc, curr) => {
        acc[curr.name] = curr
        return acc
    }, {})

    return targetComponents.filter(curr => !devComponentsMap[curr.name])
}

/**
 * 监听组件开发服务更新
 * @param {string} type 事件类型
 * @param host
 * @param port
 * @param {function} callback 回调函数
 */
export function watchDevServer(type, { host, port } = {}, callback = () => {}) {
    if (!window._DEV_PROTOCOL) {
        requestAnimationFrame(() => watchDevServer(type, { host, port }, callback))
        return
    }
    const wsProtocol = window._DEV_PROTOCOL === 'https' ? 'wss:' : 'ws:'

    if (!devServerWS) {
        devServerWS = new WebSocket(`${wsProtocol}//${host}:${port}/ws`)
    }
    devServerWS.addEventListener('message', file => {
        const meta = JSON.parse(file?.data)
        if (meta.type === type) {
            callback(meta.data)
        }
    })
}
